import { getNameModelUtil } from '../../../../model/utils'
import { EXERCISES_PATH } from '../../constants/path'
import getByIdExerciseSelector from '../get-by-id'
import { getCurrentIdReduxSelector } from '../../../../redux/selectors/get-current-id'
import { createSelector } from 'reselect'

export const getCurrentIdExerciseSelector = getCurrentIdReduxSelector(
  EXERCISES_PATH.DATA,
  EXERCISES_PATH.CURRENT
)

export const getCurrentExerciseSelector = (state, props) => {
  const id = getCurrentIdExerciseSelector(state, props)
  return getByIdExerciseSelector(id)(state, props)
}

export const getCurrentNameExerciseSelector = createSelector(getCurrentExerciseSelector,
  exercise => getNameModelUtil(exercise)
)
